import { Action } from 'redux';
import { initializeState } from 'src/utils/Initial';
import { isType } from 'typescript-fsa';
import * as Actions from '../actions/assessmentResult';

export interface IAssessmentResultState {
	readonly assessmentData: Actions.IAssessmentResultData;
}

/**
 * 初期化状態を定義する。
 */
const initialState: IAssessmentResultState = {
	assessmentData: {
		assessmentResultList: [],
		averageFlg: -1,
		careerName: '',
		categoryFlg: -1,
		comment: '',
		rankName: '',
	},
};

/**
 * アセスメント結果状態
 * @param state 状態
 * @param action 動作
 */
const assessmentResult = (state: IAssessmentResultState, action: Action) => {
	if (!state) {
		// State初期化処理
		state = initialState;
		state = initializeState(state);
	}

	if (isType(action, Actions.setAssessmentResultData)) {
		// アセスメント結果データ設定
		return {
			...state,
			assessmentData: {
				assessmentResultList: action.payload.assessmentResultList,
				averageFlg: action.payload.averageFlg,
				careerName: action.payload.careerName,
				categoryFlg: action.payload.categoryFlg,
				comment: action.payload.comment,
				rankName: action.payload.rankName,
			},
		};
	}

	return state;
};

export default assessmentResult;



// WEBPACK FOOTER //
// ./src/reducers/assessmentResult.ts